import ReportManager from './container'

export default ReportManager
